// extracted by mini-css-extract-plugin
export var optionGrid = "_37-7";
export var optionList = "_37-6";
export var questionsBlock = "_37-9";
export var spacer = "_37-5";
export var stepCenteredContent = "_37-3";
export var stepInner = "_37-0";
export var stepInnerFullWidth = "_37-1";
export var stepInnerLockScroll = "_37-2";
export var stepTransitionFrame = "_37-4";
export var welcomeBlock = "_37-8";